import { Box, BoxProps, Container, Flex, Grid, Heading, Text } from '@chakra-ui/react';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { CMS } from '@waitroom/models';
import * as React from 'react';
import CmsButton from '../../../../cms/components/Button/CmsButton';
import CmsForm from '../../../../cms/components/Form/CmsForm';
import VideoOrImage from '../../../../cms/components/VideoOrImage/VideoOrImage';
import { isLinkDefined } from '../../../../cms/utils/sanity';
import { blockquoteSx } from '../../Common/styles';
import { Icon } from '../../Icon/Icon';
import Markdown from '../../Markdown/Markdown';

const Horizontal = ({
  tagline,
  heading,
  content,
  contentAlign = 'center',
  testimonial,
  video,
  image,
  position,
  button,
  form,
  link,
  ...rest
}: CMS.Horizontal & BoxProps): React.ReactElement | null => {
  const isBefore = position === 'left';
  const hasVideo = video && video.file && video.file.asset._ref;
  const hasImage = image && image.asset._ref;
  const hasSecondCol = hasImage || hasVideo || form;
  const hasButton = isLinkDefined(button);
  const hasLink = isLinkDefined(link);
  return (
    <Box {...rest}>
      <Container maxW="container.2xl">
        <Grid
          templateColumns={{
            base: 'repeat(1, 1fr)',
            lg: hasSecondCol ? 'repeat(2, 1fr)' : undefined,
          }}
          gap={[12, 12, 16, 20]}
          alignItems={contentAlign}
        >
          <Flex direction="column" w="full" rowGap={8} order={isBefore ? 1 : [1, 1, 0]}>
            {tagline || heading ? (
              <div>
                {tagline && (
                  <Text size="sm" color="red.500" fontWeight="800" textTransform="uppercase" mb={2}>
                    {tagline}
                  </Text>
                )}
                {heading && (
                  <Heading as="h2" size="5xl" lineHeight="shorter">
                    {heading}
                  </Heading>
                )}
              </div>
            ) : null}
            {content && <Markdown fontSize={['lg']}>{content}</Markdown>}
            {testimonial && (
              <Box as="blockquote" sx={blockquoteSx}>
                <Text fontSize={['lg', 'xl']} mb={4}>
                  {testimonial.content}
                </Text>
                <footer>
                  <Text as="cite" fontSize="lg" fontStyle="normal" fontWeight="bold">
                    {testimonial.author}
                  </Text>
                  {testimonial.authorAbout && (
                    <Text mt={1} noOfLines={2}>
                      {testimonial.authorAbout}
                    </Text>
                  )}
                </footer>
              </Box>
            )}
            {hasButton || hasLink ? (
              <Flex rowGap={1} columnGap={[8, 10]} wrap="wrap" align="center">
                {hasButton && (
                  <CmsButton
                    data={button}
                    isButton
                    layoutBg={rest.bgColor}
                    size={['sm', 'def', 'md']}
                    minW={['150px', '150px']}
                  >
                    {button.text}
                  </CmsButton>
                )}
                {hasLink && (
                  <CmsButton
                    data={link}
                    layoutBg={rest.bgColor}
                    size={['sm', 'def', 'md']}
                    height="auto"
                    py={2}
                    rightIcon={<Icon icon={faArrowRight} />}
                  >
                    {link.text}
                  </CmsButton>
                )}
              </Flex>
            ) : null}
          </Flex>
          {hasSecondCol ? (
            <Box order={isBefore ? 0 : [0, 0, 1]}>
              <VideoOrImage video={video} image={image} size={[600, 450]} mx="auto" />
              {form && <CmsForm id={form} />}
            </Box>
          ) : null}
        </Grid>
      </Container>
    </Box>
  );
};
export default Horizontal;
